// extracted by mini-css-extract-plugin
module.exports = {"showClipForm":"CreateStreamRecordClip_showClipForm__1VKiz","hideClipForm":"CreateStreamRecordClip_hideClipForm__3SfC2"};